import Stocks from "./components/Stocks";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Stocks />
    </div>
  );
}

export default App;
